// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ChartDonutIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M17.174 3.007A2 2 0 0 0 15 5v5.084a1.983 1.983 0 0 0 1.656 1.97A4 4 0 1 1 12 16.21c-.051-1.028.159-1.875.625-2.533a1.983 1.983 0 0 0-.211-2.558L8.96 7.585a2 2 0 0 0-2.953.138 12.95 12.95 0 0 0 .867 17.533A12.905 12.905 0 0 0 16 29h.186A13.037 13.037 0 0 0 29 16.185c.094-6.787-5.101-12.575-11.826-13.177ZM7.54 8.992l3.451 3.524v.008A5.411 5.411 0 0 0 10.055 15h-5.01c.2-2.21 1.07-4.306 2.495-6.008ZM5.046 17h5.038A6 6 0 0 0 15 21.918v5.037A11 11 0 0 1 5.046 17Zm18.721 6.767A10.932 10.932 0 0 1 17 26.951v-5.034a5.944 5.944 0 0 0 3.091-1.528A6 6 0 0 0 17 10.083V5c5.69.51 10.084 5.41 10 11.156a10.931 10.931 0 0 1-3.233 7.611Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
